import { render, staticRenderFns } from "./CartButtonMobile.vue?vue&type=template&id=60687a9e&"
import script from "./CartButtonMobile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CartButtonMobile.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60687a9e')) {
      api.createRecord('60687a9e', component.options)
    } else {
      api.reload('60687a9e', component.options)
    }
    module.hot.accept("./CartButtonMobile.vue?vue&type=template&id=60687a9e&", function () {
      api.rerender('60687a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/AnalysisCard/components/CartButtonMobile.vue"
export default component.exports